import script from "./IncomeScale.vue?vue&type=script&setup=true&lang=ts"
export * from "./IncomeScale.vue?vue&type=script&setup=true&lang=ts"

import "./IncomeScale.vue?vue&type=style&index=0&id=2d78a853&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d78a853"]])

export default __exports__